export default function ComponentLoader(lazyComponent: any, attemptsLeft?: number) {
    return new Promise((resolve, reject) => {
        lazyComponent()
            .then(resolve)
            .catch((error: any) => {
                // let us retry after 1500 ms
                setTimeout(() => {
                    if (attemptsLeft === 1) {
                        reject(error);
                        return;
                    }
                    ComponentLoader(lazyComponent, (attemptsLeft ?? 20) - 1).then(resolve, reject);
                }, 1500);
            });
    }); 
}
